import React, { useContext, useRef } from 'react'
import { AppContext } from '../AppContext';
import { FontAwesome } from '../data/FontAwesome';
import { AlarmSetting, AlarmAudios } from '../data/Audios'
import { Hours, Minutes } from '../data/Common';

export default function AlarmForm() {

    const { alarmSettings, updateSettings, t } = useContext(AppContext)
    const newAlarm = useRef({})

    function saveAlarm() {
        let nar = new AlarmSetting(newAlarm.current.id.value * 1, newAlarm.current.frequency.value, newAlarm.current.hour.value, newAlarm.current.minute.value, newAlarm.current.ap.value);
        let existingIndex = alarmSettings.findIndex(f => f.hour === nar.hour && f.minute === nar.minute && f.ap === nar.ap && f.frequency === nar.frequency)
        if (existingIndex >= 0) {
            alarmSettings.splice(existingIndex, 1)
        }
        alarmSettings.push({ ...nar });
        updateSettings({ alarmSettings: alarmSettings })
        document.activeElement.blur();
    }

    return (

        <div className='alarm-form-grid'>
            <label className='alarm-field alarm-field-wide'>
                <span>{t('alarms.sound')}</span>
                <select ref={(element) => newAlarm.current.id = element} className='form-control form-control-sm'>
                    {AlarmAudios.map((q) => (<option key={'au' + q.id} value={q.id}>{q.name}</option>))}
                </select>
            </label>
            <label className='alarm-field'>
                <span>{t('alarms.frequency')}</span>
                <select ref={(element) => newAlarm.current.frequency = element} className='form-control form-control-sm'>
                    <option value='W'>{t('alarms.weekdays')}</option>
                    <option value='E'>{t('alarms.everyday')}</option>
                </select>
            </label>
            <div className='alarm-time-fields'>
                <label className='alarm-field'>
                    <span>{t('alarms.hour')}</span>
                    <select ref={(element) => newAlarm.current.hour = element} className='form-control form-control-sm'>
                        {Hours.map((each, index) => (<option key={'hour' + index} value={index + 1}>{index + 1}</option>))}
                    </select>
                </label>
                <label className='alarm-field'>
                    <span>{t('alarms.minute')}</span>
                    <select ref={(element) => newAlarm.current.minute = element} className='form-control form-control-sm'>
                        {Minutes.map((each, index) => {
                            let mv = index < 10 ? '0' + index : index;
                            return (<option key={'minute' + mv} value={mv}>{mv}</option>)
                        })}
                    </select>
                </label>
                <label className='alarm-field'>
                    <span>{t('alarms.period')}</span>
                    <select ref={(element) => newAlarm.current.ap = element} className='form-control form-control-sm'>
                        <option value='am'>{t('common.am')}</option>
                        <option value='pm'>{t('common.pm')}</option>
                    </select>
                </label>
            </div>
            <button onClick={saveAlarm} className='alarm-submit'>{FontAwesome.Plus} {t('alarms.save')}</button>
        </div>

    )
}
